<div class="d-flex align-items-center">
  <button class="p-0 btn mt-1" (click)="open(content)">
    <fa-icon class="d-inline" [icon]="['fass', 'bars']" [size]="'3x'" style="color: black"></fa-icon>
  </button>
</div>

<ng-template #content let-offcanvas>
  <div class="main-menu-wrapper">
    <div class="offcanvas-body">
      <div class="d-flex flex-column main-menu">
        <ng-container *ngFor="let item of headerMenu.items">
          <div class="h-100 d-flex align-items-center" routerLinkActive="active">
            <a [routerLink]="item.url" *ngIf="!item.url.includes('http')" (click)="offcanvas.dismiss()">
              <span>{{ item.label }}</span>
            </a>
            <a [href]="item.url" target="_blank" *ngIf="item.url.includes('http')">
              <span>{{ item.label }}</span>
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
